import React from "react";
import { connect } from 'dva';
import { templateConfig, reduxTemplateConfig } from './config';
import { framework_tool, component_tool } from "@/tool";

let { WizContainer, WizReduxTemplate } = framework_tool
let { WizBrowserExport, WizModal } = component_tool

class WatermarkManager extends WizContainer {
  componentName = 'watermarkManager'

  constructor(props) {
    super(props);
    this.state = {}
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _render() {
    let _templateConfig = templateConfig()
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        enable: this._handleCMD,
      }
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(WatermarkManager);